'use client'
import { FC, Dispatch, SetStateAction } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import { TripTypeToggle } from '@/root/modules/tuuleliinid/SelectDateTimePage/components/TripTypeToggle'

interface DirectionHeaderProps {
  hideRoundtripButton: boolean
  setHideRoundTripButton: Dispatch<SetStateAction<boolean>>
}

export const DirectionHeader: FC<DirectionHeaderProps> = ({ hideRoundtripButton, setHideRoundTripButton }) => {
  const { getTranslation } = useGetTranslations()

  return (
    <div className="flex w-full flex-col items-start gap-8">
      <div className="text-base-medium-light w-full text-center text-2xl leading-tight font-bold">
        {getTranslation('selectDirectionAndTime')}
      </div>

      {/* Toggle hidden on mobile, shown on tablet+ */}
      <div className="hidden md:block">
        <TripTypeToggle hideRoundtripButton={hideRoundtripButton} setHideRoundTripButton={setHideRoundTripButton} />
      </div>
    </div>
  )
}
